import React, { useState } from 'react';
import Plus from 'assets/svg/Plus';
import Minus from 'assets/svg/Minus';
import { formatWord } from 'utils/helperMethods';
import { MultiSelectionDropDown } from './MultiSelectionDropDown';
import styled from '@emotion/styled';
import tw from 'twin.macro';
import { trackEventMixpanel } from 'utils/mixpanel';
import { GLOBAL_FILTER_ATTRIBUTE_EXPAND_COLLAPSE } from 'utils/mixpanelEventNames';
import _ from 'lodash';

interface Props {
    globalFilterContainerId: string;
    allDimAndAttributeType: any;
    allCheckedAttribute: any;
    attributeTypeExpandClose: any;
    setAttributeTypeExpandClose: any;
    expandFilter: () => void;
    screenFilterConfig: any;
    uppercaseFilterLabels?: boolean;
}

let minimumSelection = {
    Brand: 1,
    CHANNEL: 1,
    CONSUMPTION: 1,
    COUNTRY: 1,
    DIVISION: 1,
    Manufacturer: 1,
    PACK_SIZE: 1,
    PACK_TYPE_LEVEL_1: 1,
    PACK_TYPE_LEVEL_2: 1,
    PPG: 1,
    RETAILER: 1,
    SEASONAL_PACKAGING: 1,
    SUB_CATEGORY: 1,
};

export const SelectionCapsul = styled.span`
    ${tw`text-smallWord bg-bgBackground p-1.5 rounded text-purpleFont flex w-fit items-center gap-2`}
`;

function FilterAttributeNameList({
    globalFilterContainerId,
    allDimAndAttributeType,
    allCheckedAttribute,
    attributeTypeExpandClose,
    setAttributeTypeExpandClose,
    expandFilter,
    screenFilterConfig,
    uppercaseFilterLabels,
}: Props) {
    const disabledAttributeTypes: string[] = screenFilterConfig?.disabledAttributeTypes ?? [];
    return (
        <div>
            {allDimAndAttributeType.dimentions?.length > 0 &&
                allDimAndAttributeType.dimentions?.map((dim: any, key: number) => {
                    return (
                        <div
                            className={` flex-col items-center justify-between font-sm ${
                                allDimAndAttributeType.dimentions.length != key + 1 && `border-b border-borderLine`
                            }`}
                            key={dim.dimensionName}
                        >
                            {dim?.attribute?.map((attributeType: any, attributeTypeKey: number) => {
                                const isAttributeDisabled = disabledAttributeTypes?.includes(
                                    _.snakeCase(attributeType?.name),
                                );
                                return (
                                    <div
                                        className={`flex-col  px-3.2 ${
                                            attributeTypeExpandClose === attributeType.name
                                                ? `bg-lightPurpleBg border-y border-borderLine mb-3.2`
                                                : `pb-6`
                                        } ${attributeTypeKey === 0 && `pt-3`} ${
                                            isAttributeDisabled ? 'pointer-events-none' : ''
                                        }`}
                                        key={attributeTypeKey}
                                    >
                                        <div
                                            className={`  ${attributeTypeExpandClose === attributeType.name && `pt-2`}`}
                                            key={attributeType.name}
                                            onClick={(e) => {
                                                //if this attribute type is disabled then dont expand/collapse
                                                if (isAttributeDisabled) return;
                                                setAttributeTypeExpandClose((oldValue: String) =>
                                                    oldValue == attributeType.name ? '' : attributeType.name,
                                                );

                                                //mixpanel event
                                                trackEventMixpanel(GLOBAL_FILTER_ATTRIBUTE_EXPAND_COLLAPSE, {
                                                    isExpanded:
                                                        attributeTypeExpandClose === attributeType?.name ? false : true,
                                                    attributeType: attributeType?.name,
                                                    dimension: attributeType?.dimensionReference || '',
                                                });
                                            }}
                                        >
                                            <div>
                                                <div className="flex justify-between items-center cursor-pointer">
                                                    <span>
                                                        {uppercaseFilterLabels
                                                            ? formatWord(attributeType.name).toUpperCase()
                                                            : formatWord(attributeType.name)}
                                                    </span>
                                                    <span>
                                                        {attributeTypeExpandClose === attributeType.name ? (
                                                            <Minus />
                                                        ) : (
                                                            <Plus />
                                                        )}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={`mr-2 flex flex-wrap gap-2`}>
                                            {!(attributeTypeExpandClose === attributeType.name) &&
                                                allCheckedAttribute?.[attributeType.name] &&
                                                Object.keys(allCheckedAttribute?.[attributeType.name])
                                                    .slice(0, 3)
                                                    .map((attributeName: string, index) => {
                                                        if (index === 2)
                                                            return (
                                                                <SelectionCapsul
                                                                    key={attributeName}
                                                                    className="cursor-pointer"
                                                                    onClick={expandFilter}
                                                                >
                                                                    +
                                                                    {Object.keys(
                                                                        allCheckedAttribute?.[attributeType.name],
                                                                    ).length - 2}{' '}
                                                                    more
                                                                </SelectionCapsul>
                                                            );
                                                        return (
                                                            <SelectionCapsul key={attributeName}>
                                                                {attributeName}
                                                            </SelectionCapsul>
                                                        );
                                                    })}
                                        </div>
                                        {attributeTypeExpandClose === attributeType.name && (
                                            <div className="mt-2 z-30 mb-3">
                                                <MultiSelectionDropDown
                                                    globalFilterContainerId={globalFilterContainerId}
                                                    attributeType={attributeType}
                                                    dimension={dim}
                                                    attributeTypeExpandFlag={
                                                        attributeTypeExpandClose === attributeType.name
                                                    }
                                                />
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    );
                })}
        </div>
    );
}

export default FilterAttributeNameList;
